import { Grid } from '@mui/material';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { Holders } from 'civil-status/view-models/step-form';
import { DatePicker } from '@mui/lab';
import { noop } from 'shell/utils/noop';
import MunicipalityList from 'shell/components/shared/municipality-list';
import ForeignStateList from 'shell/components/shared/foreign-state-list';

interface FormHolderProps {
  values: Holders;
}

const FormComponent = ({ values }: FormHolderProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          disabled
          value={values.name || ''}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          disabled
          value={values.surname || ''}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscalCode"
          fullWidth
          disabled
          value={values.fiscalCode || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data nascita"
          aria-label="Data nascita"
          value={values?.dateBorn || null}
          disabled
          onChange={noop}
          renderInput={(params) => (
            <PmiTextField {...params} id="dateBorn" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MunicipalityList
          value={values?.municipality || null}
          required
          disabled
          label="Comune"
          onChange={noop}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <PmiTextField
          label="Provincia"
          aria-label="Provincia"
          id="province"
          fullWidth
          disabled
          value={values.municipality?.province || ''}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ForeignStateList value={values?.state || null} onChange={noop} disabled label="Nazione" />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="ID Anpr"
          aria-label="ID Anpr"
          id="idAnpr"
          fullWidth
          disabled
          value={values.idAnpr || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Identificativo unico nazionale"
          aria-label="Identificativo unico nazionale"
          id="idNationalIdentifier"
          fullWidth
          disabled
          value={values.idNationalIdentifier || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="ID Ansc Soggetto"
          aria-label="ID Ansc Soggetto"
          id="idAnsc"
          fullWidth
          disabled
          value={values.idAnsc || ''}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Form Head component';

const Form = memo(FormComponent);

export default Form;
